<div nz-row nzType="flex">
    <div nz-col nzSpan="10">
        <div class="formname">{{formTitle}}</div>
    </div>

    <div nz-col nzSpan="14" style="display: flex; justify-content: flex-end;">
        <form nz-form [nzLayout]="'inline'">
            <nz-form-item>
                <button nz-button [nzType]="isFilterApplied" (click)="showFilter()"><i nz-icon
                        nzType="filter"></i></button>
            </nz-form-item>

            <nz-form-item>
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                    <input type="text" autocomplete="off" name="search" nz-input placeholder="Search Records"
                        [(ngModel)]="searchText" (keydown.enter)="onEnterKeyDown()" />
                </nz-input-group>

                <ng-template #suffixIconButton>
                    <button nz-button id="button1" nzType="primary" (click)="getAllFeatures()" nzSearch><i nz-icon
                            nzType="search"></i></button>
                </ng-template>
            </nz-form-item>

            <!-- <nz-form-item>
                <button nz-button nzType="primary" (click)="add()"><i nz-icon nzType="plus"></i>New Feature</button>
            </nz-form-item> -->
        </form>
    </div>
</div>

<div nz-row>
    <div nz-col nzSpan="24">
        <div class="filter {{filterClass}}">
            <div class="filter-box">
                <form nz-form>
                    <div nz-row nzGutter="16">
                        <div nz-col nzSpan="14">
                            <nz-form-label nzNoColon>Module Name</nz-form-label>

                            <nz-input-group>
                                <nz-select name="moduleName" nzMode="multiple" style="width: 100%;" nzShowSearch
                                    style="width: 100%" [(ngModel)]="moduleID">
                                    <nz-option *ngFor="let module of moduleList" [nzValue]="module.ID"
                                        [nzLabel]="module.NAME"></nz-option>
                                </nz-select>
                            </nz-input-group>
                        </div>

                        <div nz-col nzSpan="10">
                            <nz-form-label>Actions</nz-form-label><br />

                            <nz-button-group nzSize="default">
                                <button style="margin-right: 10px;" nz-button nzType="primary"
                                    (click)="getAllFeatures(true)" nzJustify="end">
                                    <i nz-icon nzType="filter"></i>Apply Filter
                                </button>

                                <button nz-button nzType="primary" (click)="clearFilter()">
                                    <i nz-icon nzType="filter"></i>Clear Filter
                                </button>
                            </nz-button-group>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div nz-row>
    <div nz-col nzSpan="24">
        <nz-table class="my-scroll no-wrap1" nzBordered #table nzShowSizeChanger [nzFrontPagination]="false"
            [nzData]="featureData" [nzLoading]="loadingRecords" [nzTotal]="totalRecords" [(nzPageIndex)]="pageIndex"
            [(nzPageSize)]="pageSize" (nzQueryParams)="sort($event)">

            <thead>
                <tr>
                    <!-- <th style="text-align: center;">View</th> -->
                    <th style="text-align: center;">Edit</th>
                    <!-- <th style="text-align: center;">Map</th> -->
                    <th *ngFor="let column of columns" nzColumnKey="{{column[0]}}" [nzSortFn]="true">{{column[1]}}</th>
                    <th nzColumnKey="START_DATE" [nzSortFn]="true">Start Date</th>
                    <th nzColumnKey="END_DATE" [nzSortFn]="true">End Date</th>
                    <th style="text-align: center;" nzColumnKey="IS_ACTIVE" [nzSortFn]="true">Active</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let data of table.data">
                    <!-- <td style="text-align: center;"><a (click)="viewFeatureDetails(data)"><i nz-icon nzType="eye"
                                nzTheme="outline"></i></a></td> -->
                    <td style="text-align: center;"><a (click)="edit(data)"><i nz-icon nzType="edit"
                                nzTheme="outline"></i></a></td>
                    <!-- <td style="text-align: center;"><a (click)="mapFeature(data)"><i nz-icon nzType="form"
                                nzTheme="outline"></i></a></td> -->
                    <td *ngFor="let column of columns">{{data[column[0]]}}</td>
                    <td>{{data.START_DATE | date: 'dd MMM, yyyy'}}</td>
                    <td>{{data.END_DATE | date: 'dd MMM, yyyy'}}</td>
                    <td style="text-align: center;">
                        <i nz-icon *ngIf="data.IS_ACTIVE" [nzType]="'check-circle'" [nzTheme]="'twotone'"
                            [nzTwotoneColor]="'#52c41a'"></i>
                        <i nz-icon *ngIf="!data.IS_ACTIVE" [nzType]="'close-circle'" [nzTheme]="'twotone'"
                            [nzTwotoneColor]="'#f50'"></i>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</div>

<div >
    <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
        [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="700" [nzVisible]="drawerVisible"
        [nzTitle]="drawerTitle" (nzOnClose)="drawerClose()" (nzKeyboard)="true">

        <app-feature-drawer [drawerClose]="callBackDrawerClose" [data]="featureDrawerData"
            [ShowLinkOrNot]="showWorkLogsLink"></app-feature-drawer>
    </nz-drawer>
</div>

<div >
    <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
        [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="800" [nzVisible]="mappingDrawerVisible"
        [nzTitle]="mappingDrawerTitle" (nzOnClose)="mappingDrawerClose()" (nzKeyboard)="true">

        <app-feature-mapping [drawerClose]="callBackMappingDrawerClose" [data]="featureDrawerData"
            [mappingData]="featureMappingDrawerData"></app-feature-mapping>
    </nz-drawer>
</div>

<div  >
    <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
        [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="700"
        [nzVisible]="viewFeatureDrawerVisible" [nzTitle]="viewFeatureDrawerTitle"
        (nzOnClose)="viewFeatureDetailsDrawerClose()" (nzKeyboard)="true">

        <app-feature-view [featureData]="featureDrawerData" [type]="type" [typeID]="typeID" [roadmaptrue]="roadmaptrue"></app-feature-view>
    </nz-drawer>
</div>